module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1245-retro.6a52064b.jpg";